import {ins as axios} from './axios'
import Version from '@/version'
const defaultState = () => {
  return {
    isLogin: false,
    user: {},
    accessToken: null,
    refreshToken: null,
    sideBarToggle: false,
    projectListOnlyMe: false,
    projectOnlyOn: false,
    userBackgroundImage: []
  }
}

export const defaultModule = {
  state: defaultState,
  getters: {
    isLogin: state => {
      return state.isLogin
    },
    accessToken: state => {
      // return this._vm.$cookies.get('accessToken')
      return state.accessToken
    },
    user: state => {
      return state.user
    },
    refreshToken: state => {
      return state.refreshToken
    },
    sideBarToggle: state => {
      return state.sideBarToggle
    },
    projectListOnlyMe: state => {
      return state.projectListOnlyMe
    },
    userBackgroundImage: state => {
      return state.userBackgroundImage
    },
    projectOnlyOn: state => {
      return state.projectOnlyOn
    }
  },
  mutations: {
    increment (state) {
      state.count += 1
    },
    setRefreshToken (state, payload) {
      state.refreshToken = payload
    },
    signInSuccess (state, payload) {
      const {accessToken, refreshToken} = payload
      state.accessToken = accessToken
      state.refreshToken = refreshToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
      axios.defaults.headers.common['Panel-Hub-Version'] = Version
    },
    verify (state, {userID, userName, userImage, userGroup, objectID, userGroupID, auth}) {
      if (!state.isLogin) {
        state.isLogin = true
        state.user = {userID, userName, userImage, userGroup, objectID, userGroupID, auth}
      }
    },
    updateInfo (state, {userID, userName, userImage, userGroup, objectID, userGroupID, auth}) {
      state.user = {userID, userName, userImage, userGroup, objectID, userGroupID, auth}
      this.dispatch('changeProfile', state.user).then(result => {
      })
    },
    userBackgroundImage (state, userBackgroundImage) {
      state.userBackgroundImage = userBackgroundImage
    },
    logout (state) {
      Object.assign(state, defaultState())
      // const initial = initialState()
      // Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    sideBarToggle (state) {
      state.sideBarToggle = !state.sideBarToggle
    },
    projectListOnlyMe (state, payload) {
      state.projectListOnlyMe = payload
    },
    projectOnlyOn (state, payload) {
      state.projectOnlyOn = payload
    }
  },
  actions: {
    increment (context) {
      context.commit('increment')
    },
    thirdPartyLogin (context, {accessToken, refreshToken}) {
      context.commit('signInSuccess', {accessToken, refreshToken})
    },
    verify (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await axios({
            url: '/auth/token/verify',
            method: 'get',
            headers: {
              'Authorization': `Bearer ${this.getters.accessToken}`,
              'Panel-Hub-Version': Version
            }
          })
          if (data) context.commit('verify', data)
          return resolve(data)
        } catch (e) {
          return reject(e)
        }
      })
    },
    accessTokenRequest (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          if (!this.getters.refreshToken) return reject(new Error('Token expired'))
          const {data} = await axios({
            url: '/auth/token/refresh',
            method: 'get',
            params: {refreshToken: this.getters.refreshToken}
          })
          context.commit('signInSuccess', {accessToken: data.accessToken, refreshToken: data.refreshToken, ...payload})
          return resolve(data)
        } catch (e) {
          return reject(e)
        }
      })
    },
    signIn (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          context.commit('logout')
          const {data} = await axios({
            url: '/auth/sign-in',
            method: 'post',
            data: payload
          })
          if (!data) return reject(new Error('No data'))
          const {accessToken, refreshToken} = data
          if (accessToken && refreshToken) {
            context.commit('signInSuccess', {accessToken, refreshToken, ...payload})
            // MARK: 로그인시 Firebase init
            // MARK: 로그인시 Socket
            if (context.getters.notificationPermission) {
              if (!context.getters.firebaseToken) await context.dispatch('firebaseInit', {})
              if (!context.getters.isConnected) await context.dispatch('socketConn', {})
            }
            return resolve(data)
          }
        } catch (e) {
          return reject(e)
        }
      })
    },
    logout (context) {
      context.commit('logout')
      context.dispatch('firebaseLogout')
      context.dispatch('disconnect')
    },
    updateInfo (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios({
            url: '/auth/token/verify',
            method: 'patch',
            headers: {
              'Authorization': `Bearer ${payload.accessToken}`,
              'Panel-Hub-Version': Version
            }
          })
          let data = res.data
          if (data.result === false) return reject(data.errMsg || 'Verify Fail')
          context.commit('signInSuccess', data)
          context.commit('updateInfo', data)

          return resolve(res)
        } catch (e) {
          return reject(e)
        }
      })
    },
    cancelHttp (context, payload) {
    },
    sideBarToggle (context) {
      context.commit('sideBarToggle')
    },
    projectListOnlyMe (context, payload) {
      context.commit('projectListOnlyMe', payload)
    },
    projectOnlyOn (context, payload) {
      context.commit('projectOnlyOn', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/default.store.js